import React from 'react';
import PropTypes from 'prop-types';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const RoomsList = (props) => {
	useStyles(css);
	const { title, children, id } = props;

	return (
		<div className={css.wrap} id={id}>
			{title && <div className={css.label}>{title}</div>}
			{children}
		</div>
	);
};

RoomsList.propTypes = {
	id: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
};

RoomsList.defaultProps = {
	id: undefined,
	title: null,
	children: null,
};

export default RoomsList;
